<template>
    <div>

        <div class="tab-content epilot-content">
            <form>
                <section v-if="validStep && currentStep" class="enable-bootstrap" :class="currentStep.typ == 0 ? 'bg-lightblue carousel-wb' : 'carousel-ip'">
                    <div v-if="currentStep.text1" class="wrapper gutter-big pt-60 pb-60">
                        <div class="row">
                            <div class="columns small-12" v-html="currentStep.text1">
                            </div>
                        </div>
                    </div>
                    <div class="carousel-wrapper" v-if="typeof products !== 'undefined' && products.length > 0">
                        <Carousel :items-to-show="slidesToShow">
                            <Slide v-for="(product, index) in products" :key="index">
                                <div v-if="currentStep.typ == 0" class="slide-wb" :class="selectedClass(product) + ' ' + (product.tipp ? 'highlighted' : '')">
                                    <div v-if="product.tipp" class="highlight-batch">Unser Tipp</div>
                                    <div class="card">
                                        <img v-if="product.image" class="card-img-top" :src="product.image" alt="">
                                        <div class="d-flex justify-content-between flex-column h-100">
                                            <div class="card-body text-left">
                                                <span v-for="tag in product._tags" :key="tag" class="rte-kicker-blue">
                                                    {{ tag }}
                                                </span>
                                                <h3 class="card-title">{{ product._title }}</h3>
                                                <ul v-if="typeof product.feature !== 'undefined' && product.feature.length" class="check checkout">
                                                    <li v-for="feature in product.feature" :key="feature">
                                                        {{ feature.feature }}
                                                    </li>
                                                </ul>
                                                <!-- <ul class="infolist">
                                                    <li>
                                                        <p>
                                                            inklusive fahr-e check (im Wert von 199,00 Euro)
                                                            <span class="info-tooltip info-tooltip_small" data-toggle="modal" data-target="#exampleModalLong">
                                                                i
                                                            </span>
                                                        </p>
                                                    </li>
                                                    <li>
                                                        <p>
                                                            Lieferung bei Montage frei Haus
                                                            <span class="info-tooltip info-tooltip_small" data-toggle="modal" data-target="#exampleModalLong">
                                                                i
                                                            </span>
                                                        </p>
                                                    </li>
                                                </ul> -->
                                            </div>
                                            <div class="card-footer">
                                                <div v-if="product.one_time_price" class="price">
                                                    <span>ab</span>
                                                    {{ product.one_time_price.unit_amount_decimal }} €
                                                    <p>
                                                        <small v-if="product.one_time_price.is_tax_inclusive">inkl. MwSt.</small>
                                                    </p>
                                                </div>
                                                <div class="form-check pl-0 pr-0 pt-3 pb-3">
                                                    <input @click="isInBasket(product) ? removeFromBasket(product) : addToBasket(product)" :checked="isInBasket(product)" class="add-on form__checkbox js-checkbox-toggle w-100" :id="product.name.replaceAll(' ', '-')" type="checkbox">
                                                    <label class="form__label pb-3 pt-3" :for="product.name.replaceAll(' ', '-')">AUSWÄHLEN</label>
                                                </div>
                                                <div v-if="product.product_downloads && product.product_downloads.length">
                                                    <a v-for="(download, index) in product.product_downloads" :key="index" target="_blank" class="pt-3 pb-3" :href="download.public_url">Datenblatt zum Download</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="overlay" 
                                        @click="isInBasket(product) ? removeFromBasket(product) : addToBasket(product)" >
                                    </div>
                                </div>
                                <div v-else-if="currentStep.typ == 1" class="swiper-slide slide-ip" :class="selectedClass(product) + ' ' + (product.tipp ? 'highlighted' : '')">
                                    <div class="card">
                                        <img v-if="product.image" :src="product.image" class="card-img-top">
                                        <div class="d-flex justify-content-between flex-column h-100">
                                            <div class="card-body text-left">
                                                <h3 class="card-title">{{ product._title }}</h3>
                                                <p class="card-text" v-html="product.description"></p>
                                                <ul v-if="typeof product.feature !== 'undefined' && product.feature.length" class="check checkout">
                                                    <li v-for="feature in product.feature" :key="feature">
                                                        {{ feature.feature }}
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="card-footer">
                                                <div v-if="product.one_time_price" class="price">
                                                    <span>ab</span> {{ product.one_time_price.unit_amount_decimal }} €
                                                    <p>
                                                        <small v-if="product.one_time_price.is_tax_inclusive">inkl. MwSt.</small>
                                                    </p>
                                                </div>
                                                <div class="form-check pl-0 pr-0 pt-3 pb-3">
                                                    <input @click="isInBasket(product) ? removeFromBasket(product) : addToBasket(product)" :checked="isInBasket(product)" class="add-on form__checkbox js-checkbox-toggle w-100" :id="product.name.replaceAll(' ', '-')" type="checkbox" name="" value="1">
                                                    <label class="form__label pb-3 pt-3" :for="product.name.replaceAll(' ', '-')">AUSWÄHLEN</label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="overlay"
                                        @click="isInBasket(product) ? removeFromBasket(product) : addToBasket(product)" >
                                    </div>
                                </div>
                            </Slide>
                            <template #addons>
                            </template>
                        </Carousel>
                    </div>
                    <div v-if="currentStep.summary" class="wrapper gutter-big pt-60 pb-0">
                        <div v-show="basket.products.length > 0 || basket.services.length > 0" class="card-bottom">
                            <div class="row ">
                                <div class="columns small-12">
                                    <h2 class="pb-2">Zusammenfassung</h2>
                                    <div class="card wb-card">
                                        <div class="card-header">
                                            <h3>{{ basketTitle }}</h3>
                                        </div>
                                        <div class="card-body">
                                            <div v-for="product in basket.products" :key="product" class="product-list">
                                                <span v-for="tag in product._tags" :key="tag" class="rte-kicker-blue">
                                                    {{ tag }}
                                                </span>
                                                <p class="card-text">{{ product._title }}</p>
                                                <div v-if="product.one_time_price" class="price">
                                                    <span class="small">ab</span> {{ product.one_time_price.unit_amount_decimal }} €
                                                    <p class="pb-0 mb-0">
                                                        <small v-if="product.one_time_price.is_tax_inclusive">inkl. MwSt.</small>
                                                    </p>
                                                </div>
                                            </div>
                                            <div v-for="service in basket.services" :key="service" class="product-list">
                                                <p>{{ service._title }}</p>
                                                <p class="card-text">
                                                    <small v-html="service._description"></small>
                                                </p>
                                                <div v-if="service.one_time_price" class="price">
                                                    <span class="small">ab</span> {{ service.one_time_price.unit_amount_decimal }} €
                                                    <p class="pb-0 mb-0">
                                                        <small v-if="service.one_time_price.is_tax_inclusive">inkl. MwSt.</small>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-footer">
                                            <p>Gesamtpreis</p>
                                            <div class="price">
                                                <span class="small">ab</span> {{ basketTotalPrice }} €
                                                <p class="pb-0 mb-0">
                                                    <small>inkl. MwSt.</small>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="columns small-12">
                                <div v-html="currentStep.text"></div>
                                <fieldset id="" class="form-group">
                                    <div class="row">
                                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-radiobutton-1">
                                                    Anrede
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="form-inline mb-3">
                                                    <div id="wallboxformular-radiobutton-1" class="inputs-list radio-btn row">
                                                        <div class="form-group radio-col-width">
                                                            <div class="form-check col-12 col-sm-4">
                                                                <input v-model="formData.salutation"
                                                                    :class="{'error': validation.salutation.dirty && !validation.salutation.valid}"
                                                                    required="required"
                                                                    class="form__radio"
                                                                    id="wallboxformular-radiobutton-1-0"
                                                                    type="radio"
                                                                    value="Herr">
                                                                <label class="form__label" for="wallboxformular-radiobutton-1-0">Herr</label>
                                                            </div>
                                                            <div class="form-check col-12 col-sm-4">
                                                                <input v-model="formData.salutation"
                                                                    :class="{'error': validation.salutation.dirty && !validation.salutation.valid}"
                                                                    required="required"
                                                                    class="form__radio"
                                                                    id="wallboxformular-radiobutton-1-1"
                                                                    type="radio"
                                                                    value="Frau">
                                                                <label class="form__label" for="wallboxformular-radiobutton-1-1">Frau</label>
                                                            </div>
                                                            <div class="invalid-feedback" style="display: block;"
                                                                v-if="validation.salutation.dirty && !validation.salutation.valid">
                                                                Bitte geben Sie eine Anrede an.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6"></div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-text-1">
                                                    Vorname
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="input">
                                                    <input v-model="formData.firstName"
                                                        @blur="validateField('firstName')"
                                                        :class="{'is-invalid': validation.firstName.dirty && !validation.firstName.valid}"
                                                        required="required"
                                                        class="form-control form-input"
                                                        id="wallboxformular-text-1"
                                                        type="text">
                                                        <div class="invalid-feedback" style="display: block;"
                                                            v-if="validation.firstName.dirty && !validation.firstName.valid">
                                                            Bitte geben Sie einen Vornamen an.
                                                        </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-text-2">
                                                    Nachname
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="input">
                                                    <input v-model="formData.lastName"
                                                    @blur="validateField('lastName')"
                                                    :class="{'is-invalid': validation.lastName.dirty && !validation.lastName.valid}"
                                                    required="required"
                                                    class="form-control form-input"
                                                    id="wallboxformular-text-2"
                                                    type="text">
                                                    <div class="invalid-feedback" style="display: block;"
                                                        v-if="validation.lastName.dirty && !validation.lastName.valid">
                                                        Bitte geben Sie einen Nachnamen an.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-4 col-sm-4 col-md-2 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-text-5">
                                                    E-Mail
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="input">
                                                    <input required="required"
                                                    v-model="formData.email"
                                                    @blur="validateField('email')"
                                                    :class="{'is-invalid': validation.email.dirty && !validation.email.valid}"
                                                    class="form-control form-input"
                                                    id="wallboxformular-text-5"
                                                    type="text">
                                                    <div class="invalid-feedback" style="display: block;"
                                                        v-if="validation.email.dirty && !validation.email.valid">
                                                        Bitte geben Sie eine E-Mail an.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-4 col-sm-4 col-md-2 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-text-9">
                                                    Telefon
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="input">
                                                    <input type="tel"
                                                    @blur="validateField('phone')"
                                                    :class="{'is-invalid': validation.phone.dirty && !validation.phone.valid}"
                                                    required="required"
                                                    v-model="formData.phone"
                                                    class="form-control form-input"
                                                    id="wallboxformular-text-9">
                                                    <div class="invalid-feedback" style="display: block;"
                                                        v-if="validation.phone.dirty && !validation.phone.valid">
                                                        Bitte geben Sie eine Telefonnummer an.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <p>
                                        <strong>Rechnungs- und Lieferadresse</strong>
                                    </p>
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-text-7">
                                                    PLZ & Ort
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="input">
                                                    <input required="required"
                                                    @change="changeCity()"
                                                    @blur="hidePostalCodes()"
                                                    :class="{'is-invalid': validation.city.dirty && !validation.city.valid}"
                                                    @input="showPostalCodes()" v-model="formData.city"
                                                    class="form-control form-input"
                                                    id="wallboxformular-text-7"
                                                    type="text">
                                                    <div class="invalid-feedback" style="display: block;"
                                                        v-if="validation.city.dirty && !validation.city.valid">
                                                        Sehr geehrte Kund*innen, derzeit nehmen wir über das Formular nur Anfragen für Dortmund entgegen, melden Sie sich gerne telefonisch unter <a href="tel:02315444037">0231 544 4037</a> bei uns sollten Sie Interesse haben und nicht aus Dortmund kommen.
                                                    </div>
                                                </div>
                                                <div class="availability">
                                                    <ul v-show="showSupportedPostalCodes">
                                                        <li
                                                            class="availability-street"
                                                            v-for="(suggestion, index) in supportedPostalCodes"
                                                            :key="index"
                                                            @click="selectDeliveryCity(suggestion)"
                                                            v-show="suggestion.toLowerCase().includes(formData.city.toLowerCase()) && formData.city != ''"
                                                        >{{ suggestion }}
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-4 col-sm-4 col-md-2 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-text-3">
                                                    Straße
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="input">
                                                    <input required="required"
                                                    v-model="formData.street"
                                                    @blur="validateField('street')"
                                                    :class="{'is-invalid': validation.street.dirty && !validation.street.valid}"
                                                    class="form-control form-input"
                                                    id="wallboxformular-text-3"
                                                    type="text">
                                                    <div class="invalid-feedback" style="display: block;"
                                                        v-if="validation.street.dirty && !validation.street.valid">
                                                        Bitte geben Sie eine Straße an.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-text-11">
                                                    Hausnummer
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="input">
                                                    <input required="required"
                                                    v-model="formData.housenumber"
                                                    @blur="validateField('housenumber')"
                                                    :class="{'is-invalid': validation.housenumber.dirty && !validation.housenumber.valid}"
                                                    class="form-control form-input"
                                                    id="wallboxformular-text-11"
                                                    type="text">
                                                    <div class="invalid-feedback" style="display: block;"
                                                        v-if="validation.housenumber.dirty && !validation.housenumber.valid">
                                                        Bitte geben Sie eine Hausnummer an.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-xs-4 col-sm-4 col-md-2 col-lg-6">
                                            <div class="form-group">
                                                <label class="control-label" for="wallboxformular-text-12">
                                                    Adresszusatz
                                                </label>
                                                <div class="input">
                                                    <input v-model="formData.addressSupplement"
                                                    @blur="validateField('addressSupplement')"
                                                    :class="{'is-invalid': validation.addressSupplement.dirty && !validation.addressSupplement.valid}"
                                                    class="form-control form-input"
                                                    id="wallboxformular-text-12"
                                                    type="text">
                                                    <div class="invalid-feedback" style="display: block;"
                                                        v-if="validation.addressSupplement.dirty && !validation.addressSupplement.valid">
                                                        Bitte geben Sie einen gültigen Adresszusatz an.
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <label class="switch">
                                        <input v-model="formData.hasDifferentBillingAddress" :value="true" type="checkbox">
                                        <span class="switch-addr round hide-off"></span>
                                        <div class="toggle-label">Abweichende Rechnungsadresse</div>
                                    </label>
                                    <div v-show="formData.hasDifferentBillingAddress" class="pb-40">
                                        <div class="row">
                                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="wallboxformular-text-7">
                                                        PLZ & Ort
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input">
                                                        <input required="required"
                                                        v-model="formData.billingCity"
                                                        @blur="validateField('billingCity')"
                                                        :class="{'is-invalid': validation.billingCity.dirty && !validation.billingCity.valid}"
                                                        class="form-control form-input"
                                                        id="wallboxformular-text-7"
                                                        type="text">
                                                        <div class="invalid-feedback" style="display: block;"
                                                            v-if="validation.billingCity.dirty && !validation.billingCity.valid">
                                                            Bitte geben Sie einen Stadt an.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-4 col-sm-4 col-md-2 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="wallboxformular-text-3">
                                                        Straße
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input">
                                                        <input required="required"
                                                        v-model="formData.billingStreet"
                                                        @blur="validateField('billingStreet')"
                                                        :class="{'is-invalid': validation.billingStreet.dirty && !validation.billingStreet.valid}"
                                                        class="form-control form-input"
                                                        id="wallboxformular-text-3"
                                                        type="text">
                                                        <div class="invalid-feedback" style="display: block;"
                                                            v-if="validation.billingStreet.dirty && !validation.billingStreet.valid">
                                                            Bitte geben Sie eine Straße an.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="wallboxformular-text-11">
                                                        Hausnummer
                                                        <span class="required">*</span>
                                                    </label>
                                                    <div class="input">
                                                        <input required="required"
                                                        v-model="formData.billingHousenumber"
                                                        @blur="validateField('billingHousenumber')"
                                                        :class="{'is-invalid': validation.billingHousenumber.dirty && !validation.billingHousenumber.valid}"
                                                        class="form-control form-input"
                                                        id="wallboxformular-text-11"
                                                        type="text">
                                                        <div class="invalid-feedback" style="display: block;"
                                                            v-if="validation.billingHousenumber.dirty && !validation.billingHousenumber.valid">
                                                            Bitte geben Sie eine Hausnummer an.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="col-xs-4 col-sm-4 col-md-2 col-lg-6">
                                                <div class="form-group">
                                                    <label class="control-label" for="wallboxformular-text-12">
                                                        Adresszusatz
                                                    </label>
                                                    <div class="input">
                                                        <input required="required"
                                                        v-model="formData.billingAddressSupplement"
                                                        @blur="validateField('billingAddressSupplement')"
                                                        :class="{'is-invalid': validation.billingAddressSupplement.dirty && !validation.billingAddressSupplement.valid}"
                                                        class="form-control form-input"
                                                        id="wallboxformular-text-12"
                                                        type="text">
                                                        <div class="invalid-feedback" style="display: block;"
                                                            v-if="validation.billingAddressSupplement.dirty && !validation.billingAddressSupplement.valid">
                                                            Bitte geben Sie einen gültigen Adresszusatz an.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" v-if="formData.declarationOfIntent">
                                        <div v-for="(we, key) in formData.declarationOfIntent" :key="we" class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="form-group">
                                                <div class="input checkbox">
                                                    <div class="form-check">
                                                        <input v-model="formData.declarationOfIntent[key].agreed" class="add-on form__checkbox js-checkbox-toggle" :id="we + '-' + key" type="checkbox" :value="true">
                                                        <label class="form__label" :for="we + '-' + key" v-html="we.text">
                                                        </label>
                                                        <div class="invalid-feedback" style="display: block;"
                                                            v-if="formData.declarationOfIntent[key].dirty && !formData.declarationOfIntent[key].valid">
                                                            Bitte stimmen Sie dieser Bedingung zu.
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                            <div class="clearfix">
                                                <p>* Erforderliche Angabe</p>
                                            </div>
                                        </div>
                                    </div>
                                </fieldset>
                            </div>
                        </div>
                    </div>
                    <section class="feedback">
                        <div  v-if="currentStep.summary && (productsHaveError || servicesHaveError)" class="invalid-feedback d-flex flex-column" style="display: block;">
                            <span v-if="productsHaveError">Bitte wählen Sie eine Wallbox aus.</span>
                            <span v-if="servicesHaveError">Bitte wählen Sie ein Installationspaket aus.</span>
                        </div>
                        <div  v-else-if="currentStep.isInvalid" class="invalid-feedback d-flex flex-column" style="display: block;">
                            <span v-if="currentStep.typ == 0">Bitte wählen Sie eine Wallbox aus.</span>
                            <span v-else-if="currentStep.typ == 1">Bitte wählen Sie ein Installationspaket aus.</span>
                        </div>
                    </section>

                    <div class="wrapper gutter-big pt-20 pb-60">
                        <div class="row">
                            <div class="columns small-12">
                                <div class="cta-buttons">
                                    <button v-if="hasPrevStep" @click.prevent="prevStep" class="btn-cta btn-secondary hide-on-mobile">Zurück</button>
                                    <button v-if="hasNextStep" @click.prevent="nextStep" href="#" class="btn-cta hide-on-mobile">Weiter</button>
                                    <button v-if="currentStep.summary" @click.prevent="checkout()" :disabled="disableSubmitButton" class="btn-cta">Jetzt Kontaktanfrage absenden</button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="wrapper" v-if="configuration.disclaimer && currentStep.summary">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div v-html="configuration.disclaimer" class="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </section>
                
            </form>
        </div>
        <div class="cart-sticky" v-show="basket.products.length > 0 || basket.services.length > 0">
            <div class="card wb-card">
                <div class="card-header">
                    <span class="shopping-cart"></span><h3>{{ basketTitle }}</h3>
                </div>
                <div class="card-body">
                    <div v-for="product in basket.products" :key="product" class="product-list">
                        <span v-for="tag in product._tags" :key="tag" class="rte-kicker-blue">
                            {{ tag }}
                        </span>
                        <p class="card-text">{{ product._title }}</p>
                        <div v-if="product.one_time_price" class="price">
                            <span class="small">ab</span> {{ product.one_time_price.unit_amount_decimal }} €
                            <p class="pb-0 mb-0">
                                <small v-if="product.one_time_price.is_tax_inclusive">inkl. MwSt.</small>
                            </p>
                        </div>
                    </div>
                    <div v-for="service in basket.services" :key="service" class="product-list">
                        <p>{{ service._title }}</p>
                        <p class="card-text">
                            <small v-html="service._description"></small>
                        </p>
                        <div v-if="service.one_time_price" class="price">
                            <span class="small">ab</span> {{ service.one_time_price.unit_amount_decimal }} €
                            <p class="pb-0 mb-0">
                                <small v-if="service.one_time_price.is_tax_inclusive">inkl. MwSt.</small>
                            </p>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <p>Gesamtpreis</p>
                    <div class="price">
                        <span class="small">ab</span> {{ basketTotalPrice }} €
                        <p>
                            <small>inkl. MwSt.</small>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import { Carousel, /* Navigation, Pagination, */ Slide } from 'vue3-carousel'
import axios from "axios";
import v8n from 'v8n';

import 'vue3-carousel/dist/carousel.css';


window.supportedPostalCodes = [
    '44328 Dortmund',
    '44369 Dortmund',
    '44139 Dortmund',
    '44229 Dortmund',
    '44267 Dortmund',
    '44269 Dortmund',
    '44329 Dortmund',
    '44309 Dortmund',
    '44147 Dortmund',
    '44263 Dortmund',
    '44357 Dortmund',
    '44379 Dortmund',
    '44388 Dortmund',
    '44143 Dortmund',
    '44135 Dortmund',
    '44319 Dortmund',
    '44287 Dortmund',
    '44359 Dortmund',
    '44265 Dortmund',
    '44339 Dortmund',
    '44141 Dortmund',
    '44289 Dortmund',
    '44137 Dortmund',
    '44227 Dortmund',
    '44225 Dortmund',
    '44145 Dortmund',
    '44149 Dortmund',
    '58313 Herdecke',
];

v8n.extend({
    cityInDortmund: () => {
        return value => window.supportedPostalCodes.includes(value)
    }
});

export default {
    props: {
        configuration: Object,
        steps: Array,
    },
    components: {
        Carousel,
        Slide,
    },
    data() {
        return {
            productsHaveError: false,
            servicesHaveError: false,
            showSupportedPostalCodes: false,
            supportedPostalCodes: window.supportedPostalCodes,
            currentStep: {},
            disableSubmitButton: false,
            validStep: false,
            slidesToShow: 1.25,
            basketTitle: this.configuration.warenkorb ? this.configuration.warenkorb : 'Ihre Bestellung:',
            formData: {
                salutation: '',
                firstName: '',
                lastName: '',
                email: '',
                phone:'',
                city: '',
                street: '',
                housenumber: '',
                addressSupplement: '',
                hasDifferentBillingAddress: false,
                billingCity: '',
                billingStreet: '',
                billingHousenumber: '',
                billingAddressSupplement: '',
                declarationOfIntent: [],
            },
            basket: {
                products: [],
                services: []
            },
            validation: {
                salutation: {
                    rules: v8n().not.empty().not.undefined(),
                    dirty: false,
                    valid: false,
                },
                firstName: {
                    rules: v8n().not.empty().not.undefined().string().pattern(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{0,30}$/),
                    dirty: false,
                    valid: false,
                },
                lastName: {
                    rules: v8n().not.empty().not.undefined().string().pattern(/^[a-zA-ZàáâäãåąčćęèéêëėįìíîïłńòóôöõøùúûüųūÿýżźñçčšžÀÁÂÄÃÅĄĆČĖĘÈÉÊËÌÍÎÏĮŁŃÒÓÔÖÕØÙÚÛÜŲŪŸÝŻŹÑßÇŒÆČŠŽ∂ð ,.'-]{0,30}$/),
                    dirty: false,
                    valid: false,
                },
                city: {
                    rules: v8n().cityInDortmund(),
                    dirty: false,
                    valid: false,
                },
                street: {
                    rules: v8n().not.empty().not.undefined().string(),
                    dirty: false,
                    valid: false,
                },
                housenumber: {
                    rules: v8n()
                    .not.empty()
                    .not.undefined()
                    .string()
                    .pattern(/^[1-9][0-9]{0,5}$/),
                    dirty: false,
                    valid: false,
                },
                addressSupplement: {
                    rules: v8n()
                    .not.undefined()
                    .string()
                    .pattern(/^[A-Za-z]{0,3}$/),
                    dirty: false,
                    valid: false,
                },
                email: {
                    /* eslint-disable no-useless-escape */
                    rules: v8n().not.empty().not.undefined().string().pattern(/^\w+([\+\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,10})+$/),
                    dirty: false,
                    valid: false,
                },
                phone: {
                    /* eslint-disable no-useless-escape */
                    rules: v8n().not.empty().not.undefined().string().pattern(/^(0\d*)|^(\+\d*)|^(?![\s\S])$/),
                    dirty: false,
                    valid: false,
                },
                billingCity: {
                    rules: v8n().not.empty().not.undefined().string(),
                    dirty: false,
                    valid: false,
                    condition: () => this.formData.hasDifferentBillingAddress,
                },
                billingStreet: {
                    rules: v8n().not.empty().not.undefined().string(),
                    dirty: false,
                    valid: false,
                    condition: () => this.formData.hasDifferentBillingAddress,
                },
                billingHousenumber: {
                    rules: v8n()
                    .not.empty()
                    .not.undefined()
                    .string()
                    .pattern(/^[1-9][0-9]{0,5}$/),
                    dirty: false,
                    valid: false,
                    condition: () => this.formData.hasDifferentBillingAddress,
                },
                billingAddressSupplement: {
                    rules: v8n()
                    .not.undefined()
                    .string()
                    .pattern(/^[A-Za-z]{0,3}$/),
                    dirty: false,
                    valid: false,
                    condition: () => this.formData.hasDifferentBillingAddress,
                }, 
            }
        };
    },
    created() {
        window.addEventListener("resize", this.checkSlidesToShow);
    },
    unmounted() {
        window.removeEventListener("resize", this.checkSlidesToShow);
    },
    mounted() {
        let that = this;
        // willenserklärung setzen
        if(typeof that.configuration !== 'undefined' && typeof that.configuration.willenserklaerungen !== 'undefined') {
            that.configuration.willenserklaerungen.forEach(function(we) {
                that.formData.declarationOfIntent.push({
                    text: we.text,
                    agreed: false,
                    required: we.pflichtfeld,
                    dirty: false,
                    valid: false
                });

            });
        }
        this.checkSlidesToShow();
    },
    computed: {
        basketTotalPrice() {
            let price = 0;
            this.basket.products.forEach(function(product) {
                price += typeof product.one_time_price !== 'undefined' && product.one_time_price.unit_amount_decimal ? parseFloat(product.one_time_price.unit_amount_decimal) : 0;
            });
            this.basket.services.forEach(function(service) {
                price += typeof service.one_time_price !== 'undefined' && service.one_time_price.unit_amount_decimal ? parseFloat(service.one_time_price.unit_amount_decimal) : 0;
            });
            return price;

        },
        basketHasProduct() {
            return this.basket.products.length > 0;
        },
        basketHasService() {
            return this.basket.services.length > 0;
        },
        hasPrevStep() {
            return this.currentStep.index > 0;
        },
        hasNextStep() {
            return this.currentStep.index < this.steps.length - 1;
        },
        products() {
            let products = [];
            let product = {};
            if(typeof this.currentStep !== 'undefined' && typeof this.currentStep.elements !== 'undefined' && this.currentStep.elements.length) {
                this.currentStep.elements.forEach(function(element) {
                    product = JSON.parse(element.json);
                    if(element.bild) {
                        product.image = element.bild;
                    }
                    if(typeof product.price_options !== 'undefined' && product.price_options.length) {
                        product.one_time_price = product.price_options.find((option) => {
                            return option.type == 'one_time';
                        });
                    }
                    product.tipp = element.tipp;
                    products.push(product);
                });
            }
            return products;
        }
    },
    methods: {
        changeCity() {
            setTimeout(() => {
                this.validateField('city');
            }, 150);
        },
        hidePostalCodes() {
            setTimeout(() => {
                this.showSupportedPostalCodes = false;
            }, 150);
        },
        showPostalCodes() {
            setTimeout(() => {
                this.showSupportedPostalCodes = true;
            }, 150);
        },
        validateField(key) {

            let validationKey = key;

            if (this.validation[validationKey]) {
                
                this.validation[validationKey].dirty =  true;

                if (
                typeof this.validation[validationKey].condition !== "function" ||
                this.validation[validationKey].condition()
                ) {
                    this.validation[validationKey].valid = this.validation[validationKey].rules.test(this.formData[validationKey])
                    
                } else {
                    this.validation[validationKey].valid = true;
                }
            }
        },
        validateSteps() {
            let that = this;
            that.productsHaveError = false;
            that.servicesHaveError = false;

            that.steps.forEach(function(step) {

                step.isInvalid = false;
                if(step.summary !== true) {
                    if(step.pflichtwahl) {
                        // War schonmal im nächsten Step
                        if(step.typ == 0 && that.basket.products.length == 0) {
                            that.productsHaveError = true;
                            step.isInvalid = true;
                        } 
                        else if(step.typ == 1 && that.basket.services.length == 0) {
                            that.servicesHaveError = true;
                            step.isInvalid = true;
                        }
                    }
                }
            });
        },
        validateAll() {

            this.formData.declarationOfIntent.forEach(function(intent) {
                intent.dirty = true;

                if(intent.required) {
                    intent.valid = intent.agreed;
                }
                else {
                    intent.valid = true;
                }
            });

            const declarationOfIntentHasErrors = this.formData.declarationOfIntent.some(
                (field) => field.valid === false
            );

            this.validateSteps();
            
            Object.keys(this.validation).forEach((key) => {
                if (this.validation[key]) {
                    this.validation[key].dirty = true;

                    if (typeof this.validation[key].condition !== "function" || this.validation[key].condition()) {

                        this.validation[key].valid = this.validation[key].rules.test(this.formData[key]);
                        
                    } else {
                        this.validation[key].valid = true;
                    }
                }
            });

            const hasErros = Object.values(this.validation).some(
                (field) => field.valid === false
            );

            return hasErros || declarationOfIntentHasErrors || this.productsHaveError || this.servicesHaveError;
        },
        selectDeliveryCity(city) {
            this.formData.city = city;
            this.showSupportedPostalCodes = false;
            this.$nextTick(function() {
                this.validateField('city');
            })
        },
        checkSlidesToShow() {
            // 3 bei >= 1680
            // products.length > 3 ? 3 : products.length
            if(screen.width >= 1024) {
                this.slidesToShow = 2;
            }
            else {
                this.slidesToShow = 1.25;
            }
        },
        checkout() {
            this.disableSubmitButton = true;
            const hasError = this.validateAll();
            if(!hasError) {
                if(!this.formData.hasDifferentBillingAddress) {
                    this.formData.billingStreet = this.formData.street;
                    this.formData.billingCity = this.formData.city;
                    this.formData.billingHousenumber = this.formData.housenumber;
                    this.formData.billingAddressSupplement = this.formData.addressSupplement;
                }
                axios({
                    method: 'post',
                    url: '/?type=35648&tx_uoepilot_epilot%5Baction%5D=checkout&tx_uoepilot_epilot%5Bcontroller%5D=Konfiguration',
                    data: {
                        ...this.formData,
                        ...this.basket,
                        uid: this.configuration.uid
                    }
                })
                .then(response => {
                    if(response.data) {
                        const data = response.data;
                        if(data.success) {
                            window.location.href = this.configuration.confirmationPage;
                        }
                    }
                });
            }
            else {
                document.querySelector('.epilot-content').scrollIntoView({ behavior: "smooth"});
                this.disableSubmitButton = false;
            }
        },
        selectedClass(product) {
            if(product) {
                if((product.type === 'product' && this.basketHasProduct) || (product.type === 'service' && this.basketHasService)) {
                    return this.isInBasket(product) ? 'choose-wb' : 'fadeOut';
                }
            }
            return '';
        },
        isInBasket(product) {
            let includes = false;
            if(product) {
                if(product.type === 'product') {
                    includes = this.basket.products.find((p) => {
                        return product._id == p._id;
                    });
                }
                else if(product.type === 'service') {
                    includes = this.basket.services.find((s) => {
                        return product._id == s._id;
                    });
                }
            }
            return includes;
        },
        removeFromBasket(product) {
            if(product) {
                if(product.type === 'product') {
                    this.basket.products = this.basket.products.filter((p) => {
                        return product._id != p._id;
                    });
                }
                else if(product.type === 'service') {
                    this.basket.services = this.basket.services.filter((s) => {
                        return product._id != s._id;
                    });
                }
            }
        },
        addToBasket(product) {
            // EB: Aktuell kann es nur ein Produkt und ein Service im Warenkorb geben. Ausbaufähig, deswegen ist es ein Array.
            if(product) {
                if(product.type === 'product') {
                    this.basket.products = [];
                    this.basket.products.push(product);
                }
                else if(product.type === 'service') {
                    this.basket.services = [];
                    this.basket.services.push(product);
                }

                this.$nextTick(function() {
                    // this.validateSteps();
                    if(screen.width <= 767 && this.hasNextStep) {
                        this.nextStep();
                    }
                });
            }
        },
        prevStep() {
            let prevIndex = this.currentStep ? this.currentStep.index - 1 : false;
            let prevStep = false;
            if(prevIndex >= 0) {
                prevStep = this.steps.find((step) => {
                    return step.index == prevIndex;
                });

                if(prevStep) {
                    this.$emit('routeChange', prevIndex);
                    // this.setCurrentStep(this.getUrlEncodeOf(prevStep.title));
                }
            }
        },
        nextStep() {
            if(this.currentStep) {
                let nextIndex = this.currentStep.index + 1;
                let nextStep = false;
                if(this.steps.length && nextIndex <= this.steps.length - 1) {
                    nextStep = this.steps.find((step) => {
                        return step.index == nextIndex;
                    });
                }

                // Darf auf zum nächsten Step?
                let allowedToNextStep = false;
                this.currentStep.isInvalid = false;
                if(this.currentStep.pflichtwahl) {
                    // War schonmal im nächsten Step
                    if((this.currentStep.typ == 0 && this.basket.products.length > 0) ||
                        this.currentStep.typ == 1 && this.basket.services.length > 0) {
                            allowedToNextStep = true;
                    }
                    else {
                        this.currentStep.isInvalid = true;
                    }
                }
                else {
                    allowedToNextStep = true;
                }

                if(allowedToNextStep) {
                    if(nextStep) {
                        this.$emit('routeChange', nextIndex);
                        this.$nextTick(function() {
                            document.querySelector('.epilot-content').scrollIntoView({ behavior: "smooth"});
                        });
                        // this.setCurrentStep(this.getUrlEncodeOf(nextStep.title));
                    }
                }
            }
        },
        setCurrentStep(currentStepId) {
            this.validStep = false;
            let currentStep = null;
            if(currentStepId && typeof this.steps !== 'undefined') {
                currentStep = this.steps.find((step) => {
                    return this.getUrlEncodeOf(step.title) == currentStepId
                });

                if(currentStep) {
                    this.currentStep = currentStep;
                    this.validStep = true;
                }
            }
        },
        getUrlEncodeOf(url) {
            url = url.replaceAll(' ', '-');
            // replace all lower Umlauts
            url = url.replace("ü", "ue")
                        .replace("ö", "oe")
                        .replace("ä", "ae")
                        .replace("ß", "ss");
        
            // first replace all capital Umlauts in a non-capitalized context (e.g. Übung)
            url = url.replaceAll("Ü(?=[a-zäöüß ])", "Ue")
                        .replaceAll("Ö(?=[a-zäöüß ])", "Oe")
                        .replaceAll("Ä(?=[a-zäöüß ])", "Ae");
        
            // now replace all the other capital Umlauts
            url = url.replace("Ü", "UE")
                        .replace("Ö", "OE")
                        .replace("Ä", "AE");
            return url;
        }
    },
    watch: { 
    '$route.params.id': {
        handler: function(id) {
            this.setCurrentStep(id);
        },
        deep: true,
        immediate: true
    }
    }
}
</script>